import React from 'react';
import './Brand.css';

const publicUrl = process.env.PUBLIC_URL || '';

const assets = {
  horizontalColor: `${publicUrl}/brand/web/pulsora-logo-horizontal-light-bg.png`,
  horizontalWhite: `${publicUrl}/brand/web/pulsora-logo-horizontal-dark-bg.png`,
  monogram: `${publicUrl}/pulsora-icon-master-1024.png`,
};

export default function Brand({ compact = false, light = false, className = '' }) {
  const classes = `pulsora-brand${compact ? ' compact' : ''}${light ? ' light' : ''}${className ? ` ${className}` : ''}`;

  return (
    <span className={classes} aria-label="Pulsora">
      <img
        className="pulsora-logo pulsora-logo-full"
        src={light ? assets.horizontalWhite : assets.horizontalColor}
        alt="Pulsora"
      />
      <img
        className="pulsora-logo pulsora-logo-monogram"
        src={assets.monogram}
        alt=""
        aria-hidden="true"
      />
    </span>
  );
}
